import React from 'react';

/**
 * FoldGroup — a folded group of records, the same on phone / iPad / desktop.
 *
 *   closed  the fold surface (title · count) over the first FOLD_PEEK records, with
 *           "Show all N ›" when there are more
 *   open    every record — `openChildren` lets the caller render richer cards there
 *           (Closed Jobs shows every field), otherwise the same rows. An open body is
 *           capped at 60vh and scrolls inside (.ca-fold.is-open .ca-fold-body).
 *
 * One open at a time is the CALLER's rule: keep a single open id and pass open/onToggle.
 * `accent` colours the caret and hint (supervisor cyan, casual orange).
 * Styles: .ca-fold* in casualsAvailability.css — the sheet both availability pages load.
 * Used by: Closed Jobs (Create Jobs) and Responses on the supervisor page; Assigned Jobs
 * and Jobs Completed on the casual page.
 */
export const FOLD_PEEK = 2;

export const FoldGroup = ({ title, count, unit = 'job', accent, open, onToggle, children, openChildren = null }) => {
  const more = count > FOLD_PEEK;
  const hint = open ? 'Show less' : more ? `Show all ${count}` : openChildren ? 'Show details' : '';
  return (
    <section className={`ca-fold ${open ? 'is-open' : ''}`} style={accent ? { '--fold-accent': accent } : undefined}>
      <button type="button" className="ca-fold-head" onClick={onToggle} aria-expanded={open}>
        <svg className="ca-fold-caret" width="14" height="14" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="9 18 15 12 9 6" /></svg>
        <span className="ca-fold-title">{title}</span>
        <span className="ca-fold-count">{count} {unit}{count === 1 ? '' : 's'}</span>
        {hint && <span className="ca-fold-hint">{hint} ›</span>}
      </button>
      <div className="ca-fold-body">{open ? (openChildren ?? children) : children}</div>
    </section>
  );
};

export default FoldGroup;
